import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        header: {
            margin: 0,
            paddingInline: 0,
            paddingTop: 0,
            marginTop: remCalc(24),
            paddingBottom: remCalc(24),
        },
        body: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingX: {base: remCalc(16), md: remCalc(24)},
        },
        headerText: {
            textStyle: 'body-large',
            fontWeight: 'bold',
        },
        closeButton: {
            width: 'iconsSize.medium',
            height: 'iconsSinze.medium',
            position: 'absolute',
            right: remCalc(24),
            flexShrink: 0,
        },
        border: {
            width: '100%',
            height: remCalc(4),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            marginBottom: remCalc(22),
        },
    },
}
